import { Post } from "../../../Enterprise/modules/Post/types";

export const mockPost: Post[] = [
  {
    date: "2024-12-28T10:00:00Z",
    smart_goal_id: "ID DO SMART GOAL",
    conscious_level: "Alto",
    conscious_level_description:
      "O usuário está totalmente consciente do problema.",
    persona_id: "ID DA PERSONA",
    problem: "Alta taxa de cancelamento entre usuários premium.",
    solution: "Implementar um programa de fidelidade para membros premium.",
    category: "Retenção",
    specific_topic: "Estratégias de retenção para usuários premium",
    keyword: ["fidelidade", "retenção", "usuários premium"],
    status: "null",
    goal: "Objetivo",
  },
];
